/**
 * Safe expression evaluation for engineering calculator.
 * Supports: + - * / ^ ( ) . numbers, sqrt sin cos tan log ln pi e
 */
function evaluate(expr) {
  if (!expr || typeof expr !== 'string') return '';
  let s = expr.replace(/\s+/g, '').replace(/π/g, 'pi').replace(/\^/g, '**');
  s = s
    .replace(/\bsqrt\s*\(/g, 'Math.sqrt(')
    .replace(/\bsin\s*\(/g, 'Math.sin(')
    .replace(/\bcos\s*\(/g, 'Math.cos(')
    .replace(/\btan\s*\(/g, 'Math.tan(')
    .replace(/\blog\s*\(/g, 'Math.log10(')
    .replace(/\bln\s*\(/g, 'Math.log(')
    .replace(/\bpi\b/gi, 'Math.PI')
    .replace(/\be\b/g, 'Math.E');
  try {
    const result = Function('"use strict"; return (' + s + ')')();
    if (typeof result !== 'number' || !Number.isFinite(result)) return 'Error';
    const rounded = Number(result.toPrecision(12));
    return String(rounded);
  } catch {
    return 'Error';
  }
}

export { evaluate };
